import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { ContentColumnStyleProps, contentColumnStyles } from './atoms/content-column/list-row-content-column.styles';
import { trailingColumnStyles } from './atoms/trailing-column/list-row-trailing-column.styles';
import { TrailingColumnComponentProps } from './atoms/trailing-column/types';

export type ListRowStylesProps = {
  isClickable?: boolean;
  isSelected?: boolean;
};
const listRowStyles = ({ isClickable, isSelected }: ListRowStylesProps) => [
  css`
    position: relative;
    width: 100%;
    border-bottom: 1px solid ${theme.colors.neutral20};
    display: grid;
    grid-template-areas: 'lead content trail';
    grid-template-columns: min-content;
    padding: ${theme.spacing(2)};
    transition: background-color 250ms ease-out;
    :focus-visible {
      outline: 1px solid ${theme.colors.primary50};
    }
  `,
  isClickable &&
    css`
      :hover {
        background-color: ${theme.colors.neutral5};
        cursor: pointer;
      }
    `,
  isSelected &&
    css`
      background-color: ${theme.colors.neutral5};
    `,
];

const listRowIndicatorStyles = css`
  position: absolute;
  left: 0;
  top: 0;
  width: 8px;
  height: 100%;
  background-color: ${theme.colors.primary50};
`;

export const ListRowStyles = {
  Indicator: listRowIndicatorStyles,
  Row: (props: ListRowStylesProps) => listRowStyles(props),
  ContentColumn: (props: ContentColumnStyleProps) => contentColumnStyles(props),
  TrailingColumn: (props: TrailingColumnComponentProps) => trailingColumnStyles(props),
};
